import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import config from '../config'
import { processDataIuran, composeIuran } from '../lib/iuran'
import {request} from './authorized-request'

const hitungIuran = peserta =>
  new Promise(async (resolve, reject) => {
    const {NIK, Gaji, JHT, PeriodeProgram, Kota} = peserta
    const program = composeIuran(JHT, PeriodeProgram)
    const data = qs.stringify({
      nik: NIK,
      upah: Gaji,
      program,
      rateJHT: '',
      lokasiPekerjaan: Kota,
      biayaTransaksi: 0,
      biayaRegistrasi: 0,
      avl: '',
    })

    const result = await request('hitungiuran', 'post', data)
    if (result.data.ret === 0) {
      const dataIuran = processDataIuran(result)
      resolve({
        status: 'success',
        kode: result.data.kode,
        dataIuran
      })
    } else {
      const error = result.data.msg 
      reject({
        status: 'error',
        msg: error
      })
    }
  })

export default hitungIuran


// WEBPACK FOOTER //
// ./src/bpjs-api/hitung-iuran.js